import React, { useContext } from 'react';
import ToolTip, { ToolTipProps } from 'components/base/toolTip/ToolTip';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import cx from 'utils/classnames';
import GlobalContext from 'hooks/contexts/GlobalContext';

interface ResultCardInfoRowProps {
  label: string;
  value: string | number | React.ReactNode;
  className: string;
  toolTip?: {
    label: string;
    text: string;
  };
}

function ResultCardInfoRow({
  label,
  value,
  className,
  toolTip,
}: ResultCardInfoRowProps): React.ReactElement {
  const {
    windowSize: { currentBreakpoint },
  } = useContext(GlobalContext);

  const toolTipPositioning = {
    mobile: 'bottom',
    tablet: 'bottom',
    desktop: 'bottom',
  };

  return (
    <div
      className={cx('resultCard__infoRow', {
        [`resultCard__infoRow--${className}`]: !!className,
      })}
    >
      {!toolTip && <span className="resultCard__metaLabel">{label}</span>}
      {toolTip && (
        <div className="resultCard__metaLabel">
          <div className="resultCard__metaLabelInner">
            <span className="resultCard__metaLabelText">{label}</span>
            <div className="resultCard__metaLabelToolTip">
              <ToolTip
                label={toolTip.label}
                positioning={
                  toolTipPositioning[
                    currentBreakpoint as keyof typeof toolTipPositioning
                  ] as ToolTipProps['positioning']
                }
              >
                <Wysiwyg isClean content={toolTip.text} />
              </ToolTip>
            </div>
          </div>
        </div>
      )}
      <div className="resultCard__metaValue">
        {typeof value === 'string' ? <Wysiwyg content={value} /> : value}
      </div>
    </div>
  );
}

export default ResultCardInfoRow;
